import { render } from "./NavBarCRM.vue?vue&type=template&id=8296117c&scoped=true"
import script from "./NavBarCRM.vue?vue&type=script&lang=js"
export * from "./NavBarCRM.vue?vue&type=script&lang=js"

import "./NavBarCRM.vue?vue&type=style&index=0&id=8296117c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8296117c"]])

export default __exports__